import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

import { FlightSearchForm } from "@/features/flights/components/FlightSearchForm/FlightSearchForm";
import { useFlightSearchForm } from "@/features/flights/hooks/flightSearch/useFlightSearchForm";
import type { FlightSearchFormValues } from "@/features/flights/utils/flightsValidation";
import { SearchCategorySwitcher } from "@/features/search/components/SearchCategorySwitcher";

export const Route = createFileRoute("/_authenticated/flights/search")({
  component: RouteComponent,
});

function RouteComponent() {
  const t = useTranslations();

  const navigate = Route.useNavigate();

  const { handleSubmit: handleFlightSearchFormSubmit } = useFlightSearchForm();

  const handleFlightSearchSubmit = (values: FlightSearchFormValues) => {
    handleFlightSearchFormSubmit(values);
    navigate({ to: "/flights/departure/list" });
  };

  return (
    <main className="w-full space-y-3 p-4">
      <SearchCategorySwitcher current="flights" />

      <div className="rounded-4xl bg-surface-base-light p-4 shadow-md">
        <FlightSearchForm
          submitButtonContent={t("flights.search.searchFlight")}
          onSubmit={handleFlightSearchSubmit}
          analyticsSource="main"
        />
      </div>
    </main>
  );
}
